import React from "react";
import {
    MapPin,
    Shield,
    Users,
    Phone,
    Settings,
    AlertTriangle,
    Navigation,
    Bell,
    SquarePlus,
    Droplet,
    Search,
    Heart,
    Gauge,
    Footprints,
    RefreshCw,
    Power,
    Book,
    Wallet,
    Fence,
    Activity,
    Moon,
    Zap,
    Thermometer,
    Droplets,
    Target,
    Share2,
    PhoneCall,
    Battery,
    BatteryCharging,
    BellRing,
    Magnet,
    Pill,
    Video,
} from "lucide-react";
import { ProductIntroData } from "./types";
import { PawPrint, Baby, Car, CircleCheck, Award, Sparkles, ShieldCheck } from "lucide-react";
export const trackerData: ProductIntroData = {
    id: "tracker",
    theme: "blue",
    supportText: "ProductIntro.tracker.supportText",
    smartAssistantText: "ProductIntro.tracker.smartAssistantText",
    tagText: "ProductIntro.tracker.tagText",
    headingPart1: "ProductIntro.tracker.headingPart1",
    headingPart2: "ProductIntro.tracker.headingPart2",
    headingPart3: "ProductIntro.tracker.headingPart3",
    descriptionText: "ProductIntro.tracker.descriptionText",
    backgroundImage: "/media/home/ردیاب.webp",
    ctaText: "ProductIntro.tracker.ctaText",
    ctaLink: "/tracker",

    features: {
        pet: [
            { icon: <MapPin width="22px" height="22px" />, title: "ProductIntro.tracker.features.pet.0.title", description: "ProductIntro.tracker.features.pet.0.description" },
            { icon: <Fence width="22px" height="22px" />, title: "ProductIntro.tracker.features.pet.1.title", description: "ProductIntro.tracker.features.pet.1.description" },
            { icon: <Share2 width="22px" height="22px" />, title: "ProductIntro.tracker.features.pet.2.title", description: "ProductIntro.tracker.features.pet.2.description" },
            { icon: <Search width="22px" height="22px" />, title: "ProductIntro.tracker.features.pet.3.title", description: "ProductIntro.tracker.features.pet.3.description" },
        ],
        child: [
            { icon: <MapPin width="22px" height="22px" />, title: "ProductIntro.tracker.features.child.0.title", description: "ProductIntro.tracker.features.child.0.description" },
            { icon: <Fence width="22px" height="22px" />, title: "ProductIntro.tracker.features.child.1.title", description: "ProductIntro.tracker.features.child.1.description" },
            { icon: <Share2 width="22px" height="22px" />, title: "ProductIntro.tracker.features.child.2.title", description: "ProductIntro.tracker.features.child.2.description" },
            { icon: <PhoneCall width="22px" height="22px" />, title: "ProductIntro.tracker.features.child.3.title", description: "ProductIntro.tracker.features.child.3.description" },
        ],
        car: [
            { icon: <Fence width="22px" height="22px" />, title: "ProductIntro.tracker.features.car.0.title", description: "ProductIntro.tracker.features.car.0.description" },
            { icon: <BatteryCharging width="22px" height="22px" />, title: "ProductIntro.tracker.features.car.1.title", description: "ProductIntro.tracker.features.car.1.description" },
            { icon: <BellRing width="22px" height="22px" />, title: "ProductIntro.tracker.features.car.2.title", description: "ProductIntro.tracker.features.car.2.description" },
            { icon: <Magnet width="22px" height="22px" />, title: "ProductIntro.tracker.features.car.3.title", description: "ProductIntro.tracker.features.car.3.description" },
        ],
    },

    tabs: [
        {
            key: "pet",
            label: "ProductIntro.tracker.tabs.pet",
            icon: (
                <div className="relative w-6 h-6 flex items-center justify-center">
                    <PawPrint className="w-full h-full" />
                </div>
            ),
        },
        {
            key: "child",
            label: "ProductIntro.tracker.tabs.child",
            icon: (
                <div className="relative w-6 h-6 flex items-center justify-center">
                    <Baby className="w-full h-full" />
                </div>
            ),
        },
        {
            key: "car",
            label: "ProductIntro.tracker.tabs.car",
            icon: (
                <div className="relative w-6 h-6 flex items-center justify-center">
                    <Car className="w-full h-full" />
                </div>
            ),
        },
    ],
};

// Watch Data (Orange Theme)
export const watchData: ProductIntroData = {
    id: "watch",
    theme: "blue",
    supportText: "ProductIntro.watch.supportText",
    smartAssistantText: "ProductIntro.watch.smartAssistantText",
    tagText: "ProductIntro.watch.tagText",
    headingPart1: "ProductIntro.watch.headingPart1",
    headingPart2: "ProductIntro.watch.headingPart2",
    headingPart3: "ProductIntro.watch.headingPart3",
    descriptionText: "ProductIntro.watch.descriptionText",
    backgroundImage: "/media/home/ساعت.webp",
    ctaText: "ProductIntro.watch.ctaText",
    ctaLink: "/watches",

    features: {
        control: [
            { icon: <MapPin />, title: "ProductIntro.watch.features.control.0.title", description: "ProductIntro.watch.features.control.0.description" },
            { icon: <Fence />, title: "ProductIntro.watch.features.control.1.title", description: "ProductIntro.watch.features.control.1.description" },
            { icon: <AlertTriangle />, title: "ProductIntro.watch.features.control.2.title", description: "ProductIntro.watch.features.control.2.description" },
            { icon: <Search />, title: "ProductIntro.watch.features.control.3.title", description: "ProductIntro.watch.features.control.3.description" },
        ],
        health: [
            { icon: <Heart width="22px" height="22px" />, title: "ProductIntro.watch.features.health.0.title", description: "ProductIntro.watch.features.health.0.description" },
            { icon: <Gauge width="22px" height="22px" />, title: "ProductIntro.watch.features.health.1.title", description: "ProductIntro.watch.features.health.1.description" },
            { icon: <Footprints width="22px" height="22px" />, title: "ProductIntro.watch.features.health.2.title", description: "ProductIntro.watch.features.health.2.description" },
        ],
        tools: [
            { icon: <RefreshCw />, title: "ProductIntro.watch.features.tools.0.title", description: "ProductIntro.watch.features.tools.0.description" },
            { icon: <Power />, title: "ProductIntro.watch.features.tools.1.title", description: "ProductIntro.watch.features.tools.1.description" },
            { icon: <Book />, title: "ProductIntro.watch.features.tools.2.title", description: "ProductIntro.watch.features.tools.2.description" },
            { icon: <Wallet />, title: "ProductIntro.watch.features.tools.3.title", description: "ProductIntro.watch.features.tools.3.description" },
        ],
    },
    tabs: [
        {
            key: "control",
            label: "ProductIntro.watch.tabs.control",
            icon: (
                <div className="relative w-6 h-6 flex items-center justify-center">
                    <ShieldCheck className="w-full h-full" />
                </div>
            ),
        },
        {
            key: "health",
            label: "ProductIntro.watch.tabs.health",
            icon: (
                <div className="relative w-6 h-6 flex items-center justify-center">
                    <Heart className="w-full h-full" />
                </div>
            ),
        },
        {
            key: "tools",
            label: "ProductIntro.watch.tabs.tools",
            icon: (
                <div className="relative w-6 h-6 flex items-center justify-center">
                    <Settings className="w-full h-full" />
                </div>
            ),
        },
    ],
};

// Ring Data (Blue Theme)
export const ringData: ProductIntroData = {
    id: "ring",
    theme: "blue",
    defaultTab: "companionship",
    supportText: "ProductIntro.ring.supportText",
    smartAssistantText: "ProductIntro.ring.smartAssistantText",
    tagText: "ProductIntro.ring.tagText",
    headingPart1: "ProductIntro.ring.headingPart1",
    headingPart2: "ProductIntro.ring.headingPart2",
    headingPart3: "ProductIntro.ring.headingPart3",
    descriptionText: "ProductIntro.ring.descriptionText",
    backgroundImage: "/media/home/حلقه.webp",
    ctaText: "ProductIntro.ring.ctaText",
    ctaLink: "/rings",
    features: {
        health: [
            {
                icon: <Moon width="22px" height="22px" />,
                title: "ProductIntro.ring.features.health.0.title",
                description: "ProductIntro.ring.features.health.0.description",
            },
            {
                icon: <Zap width="22px" height="22px" />,
                title: "ProductIntro.ring.features.health.1.title",
                description: "ProductIntro.ring.features.health.1.description",
            },
            {
                icon: <Heart width="22px" height="22px" />,
                title: "ProductIntro.ring.features.health.2.title",
                description: "ProductIntro.ring.features.health.2.description",
            },
            {
                icon: <Droplet width="22px" height="22px" />,
                title: "ProductIntro.ring.features.health.3.title",
                description: "ProductIntro.ring.features.health.3.description",
            },
        ],
        companionship: [
            {
                icon: <Sparkles width="22px" height="22px" />,
                title: "ProductIntro.ring.features.companionship.0.title",
                description: "ProductIntro.ring.features.companionship.0.description",
            },
            {
                icon: <Users width="22px" height="22px" />,
                title: "ProductIntro.ring.features.companionship.1.title",
                description: "ProductIntro.ring.features.companionship.1.description",
            },
            {
                icon: <Bell width="22px" height="22px" />,
                title: "ProductIntro.ring.features.companionship.2.title",
                description: "ProductIntro.ring.features.companionship.2.description",
            },
            {
                icon: <ShieldCheck width="22px" height="22px" />,
                title: "ProductIntro.ring.features.companionship.3.title",
                description: "ProductIntro.ring.features.companionship.3.description",
            },
        ],
        special: [
            {
                icon: <Droplets width="22px" height="22px" />,
                title: "ProductIntro.ring.features.special.0.title",
                description: "ProductIntro.ring.features.special.0.description",
            },
            {
                icon: <Target width="22px" height="22px" />,
                title: "ProductIntro.ring.features.special.1.title",
                description: "ProductIntro.ring.features.special.1.description",
            },
            {
                icon: <Sparkles width="22px" height="22px" />,
                title: "ProductIntro.ring.features.special.2.title",
                description: "ProductIntro.ring.features.special.2.description",
            },
            {
                icon: <Heart width="22px" height="22px" />,
                title: "ProductIntro.ring.features.special.3.title",
                description: "ProductIntro.ring.features.special.3.description",
            },
        ],
    },

    tabs: [
        {
            key: "health",
            label: "ProductIntro.ring.tabs.health",
            icon: (
                <div className="relative w-6 h-6 flex items-center justify-center">
                    <Heart className="w-full h-full" />
                </div>
            ),
        },
        {
            key: "companionship",
            label: "ProductIntro.ring.tabs.companionship",
            icon: (
                <div className="relative w-6 h-6 flex items-center justify-center">
                    <Users className="w-full h-full" />
                </div>
            ),
        },
        {
            key: "special",
            label: "ProductIntro.ring.tabs.special",
            icon: (
                <div className="relative w-6 h-6 flex items-center justify-center">
                    <Sparkles className="w-full h-full" />
                </div>
            ),
        },
    ],
};

export const womenSmartAssistantIcon = (
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M7.28528 10.6329C7.93235 7.67959 9.3524 5.19058 11.7783 3.32313C12.2103 2.99054 12.603 3.39178 12.9262 3.66549C13.9023 4.49417 14.7409 5.47239 15.4106 6.56368C16.1363 7.7287 16.7743 9.29506 16.9946 10.6574C17.1875 10.5116 17.6221 10.3118 17.8538 10.2076C19.4624 9.48764 21.2109 9.13423 22.9729 9.17302C23.4876 9.18137 23.9803 9.07021 24.28 9.55173V10.7975C24.2176 10.9925 24.1349 11.8428 24.0839 12.1315C23.8793 13.2406 23.5171 14.3148 23.0087 15.3215C21.7615 17.8055 19.5679 19.6838 16.9214 20.5336C15.348 21.0448 13.8393 21.1281 12.205 21.0753C11.6753 21.0793 11.1458 21.099 10.6161 21.0796C8.58903 21.0077 6.66156 20.493 4.94624 19.3974C2.33016 17.7398 0.632783 14.9035 0.158162 11.8679C0.115952 11.598 0.0816709 11.0056 0 10.7755V9.5414C0.105387 9.37959 0.23677 9.2212 0.450005 9.20444C2.75727 9.02289 5.25524 9.48162 7.28528 10.6329Z"
            fill="url(#paint0_linear_2573_42339_women)"
        />
        <path
            d="M12.1403 4.19141C12.1829 4.20336 12.3698 4.36902 12.4127 4.40582C13.1055 5.00538 13.7217 5.68804 14.2474 6.43835C17.4628 11.0414 16.8772 16.8443 12.1534 20.1423C12.0821 20.1159 11.9157 19.9945 11.844 19.9414C9.07733 17.8895 7.62328 14.6235 8.11319 11.2035C8.44002 9.06151 9.38175 7.0605 10.824 5.44344C11.1853 5.03222 11.7007 4.52042 12.1403 4.19141Z"
            fill="url(#paint1_linear_2573_42339_women)"
        />
        <path
            d="M22.1025 10.0875C22.5332 10.0601 22.9588 10.0711 23.3897 10.082C23.241 15.3077 20.0063 19.3912 14.7302 20.0987C14.332 20.1441 13.9542 20.1654 13.5569 20.2007C14.0116 19.7929 14.393 19.4349 14.7899 18.9647C16.5318 16.9235 17.3708 14.2626 17.1145 11.5914C17.4351 11.4531 17.8036 11.2268 18.1503 11.0705C19.3936 10.4957 20.7348 10.1622 22.1025 10.0875Z"
            fill="url(#paint2_linear_2573_42339_women)"
        />
        <path
            d="M1.45902 10.0648C2.9954 10.052 4.51719 10.3636 5.92491 10.9792C6.31277 11.1457 6.84542 11.4614 7.16964 11.581C7.11375 12.0233 7.11283 12.5268 7.13234 12.9708C7.23046 15.1869 8.07021 17.3058 9.51683 18.9874C9.92272 19.4638 10.237 19.7586 10.6979 20.1806C10.5503 20.1793 10.377 20.1659 10.2276 20.1579C7.84099 20.0293 5.59922 19.1063 3.89215 17.4207C1.98023 15.5327 0.915818 12.7448 0.895996 10.0755L1.45902 10.0648Z"
            fill="url(#paint3_linear_2573_42339_women)"
        />
        <defs>
            <linearGradient id="paint0_linear_2573_42339_women" x1="12.14" y1="3.19727" x2="12.14" y2="21.089" gradientUnits="userSpaceOnUse">
                <stop stopColor="#FFE4E8" />
                <stop offset="1" stopColor="#FF7B8C" />
            </linearGradient>
            <linearGradient id="paint1_linear_2573_42339_women" x1="12.1409" y1="4.19141" x2="12.1409" y2="20.1423" gradientUnits="userSpaceOnUse">
                <stop stopColor="#FFE4E8" />
                <stop offset="1" stopColor="#FF7B8C" />
            </linearGradient>
            <linearGradient id="paint2_linear_2573_42339_women" x1="18.4733" y1="10.0703" x2="18.4733" y2="20.2007" gradientUnits="userSpaceOnUse">
                <stop stopColor="#FFE4E8" />
                <stop offset="1" stopColor="#FF7B8C" />
            </linearGradient>
            <linearGradient id="paint3_linear_2573_42339_women" x1="5.79695" y1="10.0645" x2="5.79695" y2="20.1806" gradientUnits="userSpaceOnUse">
                <stop stopColor="#FFE4E8" />
                <stop offset="1" stopColor="#FF7B8C" />
            </linearGradient>
        </defs>
    </svg>
);

export const womenBandData: ProductIntroData = {
    id: "womenBand",
    theme: "pink",
    defaultTab: "women",
    reverse: false,
    badgeIcon: womenSmartAssistantIcon,
    supportText: "ProductIntro.womenBand.supportText",
    smartAssistantText: "ProductIntro.womenBand.smartAssistantText",
    tagText: "ProductIntro.womenBand.tagText",
    headingPart1: "ProductIntro.womenBand.headingPart1",
    headingPart2: "ProductIntro.womenBand.headingPart2",
    headingPart3: "ProductIntro.womenBand.headingPart3",
    descriptionText: "ProductIntro.womenBand.descriptionText",
    backgroundImage: "/media/home/دستبند بانوان.webp",
    ctaText: "ProductIntro.womenBand.ctaText",
    ctaLink: "/smart-bands",
    features: {
        health: [
            {
                icon: <Moon width="22px" height="22px" />,
                title: "ProductIntro.womenBand.features.health.0.title",
                description: "ProductIntro.womenBand.features.health.0.description",
            },
            {
                icon: <Zap width="22px" height="22px" />,
                title: "ProductIntro.womenBand.features.health.1.title",
                description: "ProductIntro.womenBand.features.health.1.description",
            },
            {
                icon: <Heart width="22px" height="22px" />,
                title: "ProductIntro.womenBand.features.health.2.title",
                description: "ProductIntro.womenBand.features.health.2.description",
            },
            {
                icon: <Activity width="22px" height="22px" />,
                title: "ProductIntro.womenBand.features.health.3.title",
                description: "ProductIntro.womenBand.features.health.3.description",
            },
        ],
        women: [
            {
                icon: <Heart width="22px" height="22px" />,
                title: "ProductIntro.womenBand.features.women.0.title",
                description: "ProductIntro.womenBand.features.women.0.description",
            },
            {
                icon: <Baby width="22px" height="22px" />,
                title: "ProductIntro.womenBand.features.women.1.title",
                description: "ProductIntro.womenBand.features.women.1.description",
            },
            {
                icon: <Activity width="22px" height="22px" />,
                title: "ProductIntro.womenBand.features.women.2.title",
                description: "ProductIntro.womenBand.features.women.2.description",
            },
            {
                icon: <Bell width="22px" height="22px" />,
                title: "ProductIntro.womenBand.features.women.3.title",
                description: "ProductIntro.womenBand.features.women.3.description",
            },
        ],
        special: [
            {
                icon: <Target width="22px" height="22px" />,
                title: "ProductIntro.womenBand.features.special.0.title",
                description: "ProductIntro.womenBand.features.special.0.description",
            },
            {
                icon: <Sparkles width="22px" height="22px" />,
                title: "ProductIntro.womenBand.features.special.1.title",
                description: "ProductIntro.womenBand.features.special.1.description",
            },
            {
                icon: <Droplets width="22px" height="22px" />,
                title: "ProductIntro.womenBand.features.special.2.title",
                description: "ProductIntro.womenBand.features.special.2.description",
            },
            {
                icon: <ShieldCheck width="22px" height="22px" />,
                title: "ProductIntro.womenBand.features.special.3.title",
                description: "ProductIntro.womenBand.features.special.3.description",
            },
        ],
    },
    tabs: [
        {
            key: "health",
            label: "ProductIntro.womenBand.tabs.health",
            icon: (
                <div className="relative w-6 h-6 flex items-center justify-center">
                    <Heart className="w-full h-full" />
                </div>
            ),
        },
        {
            key: "women",
            label: "ProductIntro.womenBand.tabs.women",
            icon: (
                <div className="relative w-6 h-6 flex items-center justify-center">
                    <Sparkles className="w-full h-full" />
                </div>
            ),
        },
        {
            key: "special",
            label: "ProductIntro.womenBand.tabs.special",
            icon: (
                <div className="relative w-6 h-6 flex items-center justify-center">
                    <Award className="w-full h-full" />
                </div>
            ),
        },
    ],
};

export const sportsSmartAssistantIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.36362 11.6282C5.75362 11.0192 4.76562 11.0092 4.14262 11.6072C3.73862 11.9962 3.33862 12.3912 2.95262 12.7992C2.33762 13.4522 2.35162 14.3172 2.97662 14.9632C3.19103 15.1854 3.57067 15.5635 3.8091 15.7999C3.92729 15.9171 3.92787 16.108 3.81025 16.2258L3.17662 16.8602C2.63062 17.4052 2.63062 18.2902 3.17662 18.8362L5.16362 20.8232C5.70762 21.3682 6.59362 21.3682 7.13962 20.8232L7.77285 20.1884C7.89022 20.0708 8.08064 20.0707 8.19792 20.1885C8.42179 20.4132 8.7702 20.7623 8.97762 20.9672C9.66962 21.6462 10.4966 21.6832 11.2066 21.0382C11.6266 20.6572 12.0296 20.2552 12.4116 19.8352C12.9856 19.2012 12.9596 18.2252 12.3576 17.6202C10.3626 15.6192 8.36462 13.6222 6.36362 11.6282Z"
            fill="url(#paint0_linear_2588_12142_sports)"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20.9656 8.97798C20.7614 8.77058 20.4126 8.42263 20.1879 8.19906C20.0702 8.08187 20.0701 7.89152 20.1875 7.77405L20.8216 7.13998C21.3676 6.59398 21.3676 5.70898 20.8216 5.16398L18.8356 3.17698C18.2906 2.63098 17.4046 2.63098 16.8596 3.17698L16.2261 3.8105C16.1084 3.92818 15.9175 3.92772 15.8002 3.80962C15.5635 3.57119 15.1849 3.19144 14.9626 2.97698C14.3166 2.35198 13.4506 2.33798 12.7986 2.95398C12.3906 3.33898 11.9956 3.73798 11.6066 4.14298C11.0096 4.76598 11.0176 5.75298 11.6266 6.36398C13.6216 8.36498 15.6186 10.363 17.6196 12.357C18.2256 12.961 19.2006 12.986 19.8336 12.412C20.2546 12.031 20.6586 11.626 21.0386 11.207C21.6846 10.497 21.6466 9.66998 20.9656 8.97798Z"
            fill="url(#paint1_linear_2588_12142_sports)"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.6849 9.13791C12.5369 8.99291 12.2949 8.99891 12.1489 9.14491C10.7629 10.5309 10.4919 10.8029 9.11787 12.1769C8.96887 12.3259 8.96687 12.5719 9.11787 12.7189L11.3198 14.8679C11.4678 15.0129 11.7049 15.0119 11.8519 14.8649C13.0869 13.6299 14.3558 12.3619 14.8948 11.8229C15.0438 11.6739 15.0388 11.4339 14.8878 11.2869L12.6849 9.13791Z"
            fill="url(#paint2_linear_2588_12142_sports)"
        />
        <defs>
            <linearGradient id="paint0_linear_2588_12142_sports" x1="7.66281" y1="11.165" x2="7.66281" y2="21.5001" gradientUnits="userSpaceOnUse">
                <stop stopColor="#ABFFCA" />
                <stop offset="1" stopColor="#4DCE7C" />
            </linearGradient>
            <linearGradient id="paint1_linear_2588_12142_sports" x1="16.3325" y1="2.5" x2="16.3325" y2="12.8268" gradientUnits="userSpaceOnUse">
                <stop stopColor="#ABFFCA" />
                <stop offset="1" stopColor="#4DCE7C" />
            </linearGradient>
            <linearGradient id="paint2_linear_2588_12142_sports" x1="12.0046" y1="9.03223" x2="12.0046" y2="14.9759" gradientUnits="userSpaceOnUse">
                <stop stopColor="#ABFFCA" />
                <stop offset="1" stopColor="#4DCE7C" />
            </linearGradient>
        </defs>
    </svg>
);

export const bandData: ProductIntroData = {
    id: "band",
    theme: "green",
    defaultTab: "sport",
    reverse: true,
    badgeIcon: sportsSmartAssistantIcon,
    supportText: "ProductIntro.band.supportText",
    smartAssistantText: "ProductIntro.band.smartAssistantText",
    tagText: "ProductIntro.band.tagText",
    headingPart1: "ProductIntro.band.headingPart1",
    headingPart2: "ProductIntro.band.headingPart2",
    headingPart3: "ProductIntro.band.headingPart3",
    descriptionText: "ProductIntro.band.descriptionText",
    backgroundImage: "/media/home/دست بند.webp",
    ctaText: "ProductIntro.band.ctaText",
    ctaLink: "/smart-bands",
    features: {
        health: [
            {
                icon: <Moon width="22px" height="22px" />,
                title: "ProductIntro.band.features.health.0.title",
                description: "ProductIntro.band.features.health.0.description",
            },
            {
                icon: <Zap width="22px" height="22px" />,
                title: "ProductIntro.band.features.health.1.title",
                description: "ProductIntro.band.features.health.1.description",
            },
            {
                icon: <Heart width="22px" height="22px" />,
                title: "ProductIntro.band.features.health.2.title",
                description: "ProductIntro.band.features.health.2.description",
            },
            {
                icon: <Activity width="22px" height="22px" />,
                title: "ProductIntro.band.features.health.3.title",
                description: "ProductIntro.band.features.health.3.description",
            },
        ],
        sport: [
            {
                icon: <Target width="22px" height="22px" />,
                title: "ProductIntro.band.features.sport.0.title",
                description: "ProductIntro.band.features.sport.0.description",
            },
            {
                icon: <Footprints width="22px" height="22px" />,
                title: "ProductIntro.band.features.sport.1.title",
                description: "ProductIntro.band.features.sport.1.description",
            },
            {
                icon: <Activity width="22px" height="22px" />,
                title: "ProductIntro.band.features.sport.2.title",
                description: "ProductIntro.band.features.sport.2.description",
            },
            {
                icon: <Award width="22px" height="22px" />,
                title: "ProductIntro.band.features.sport.3.title",
                description: "ProductIntro.band.features.sport.3.description",
            },
        ],
        special: [
            {
                icon: <Heart width="22px" height="22px" />,
                title: "ProductIntro.band.features.special.0.title",
                description: "ProductIntro.band.features.special.0.description",
            },
            {
                icon: <Sparkles width="22px" height="22px" />,
                title: "ProductIntro.band.features.special.1.title",
                description: "ProductIntro.band.features.special.1.description",
            },
            {
                icon: <Droplets width="22px" height="22px" />,
                title: "ProductIntro.band.features.special.2.title",
                description: "ProductIntro.band.features.special.2.description",
            },
            {
                icon: <ShieldCheck width="22px" height="22px" />,
                title: "ProductIntro.band.features.special.3.title",
                description: "ProductIntro.band.features.special.3.description",
            },
        ],
    },
    tabs: [
        {
            key: "health",
            label: "ProductIntro.band.tabs.health",
            icon: (
                <div className="relative w-6 h-6 flex items-center justify-center">
                    <Heart className="w-full h-full" />
                </div>
            ),
        },
        {
            key: "sport",
            label: "ProductIntro.band.tabs.sport",
            icon: (
                <div className="relative w-6 h-6 flex items-center justify-center">
                    <Zap className="w-full h-full" />
                </div>
            ),
        },
        {
            key: "special",
            label: "ProductIntro.band.tabs.special",
            icon: (
                <div className="relative w-6 h-6 flex items-center justify-center">
                    <Award className="w-full h-full" />
                </div>
            ),
        },
    ],
};

export const elderlySmartAssistantIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM12 7C10.3431 7 9 8.34315 9 10C9 11.6569 10.3431 13 12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7ZM7.5 17.5C8.6 15.6 10.2 14.5 12 14.5C13.8 14.5 15.4 15.6 16.5 17.5C15.3 18.5 13.7 19 12 19C10.3 19 8.7 18.5 7.5 17.5Z"
            fill="url(#paint0_linear_elderly)"
        />
        <defs>
            <linearGradient id="paint0_linear_elderly" x1="3" y1="3" x2="21" y2="21" gradientUnits="userSpaceOnUse">
                <stop stopColor="#60A5FA" />
                <stop offset="1" stopColor="#155DFC" />
            </linearGradient>
        </defs>
    </svg>
);

export const elderlyWatchData: ProductIntroData = {
    id: "elderlyWatch",
    theme: "blue",
    defaultTab: "control",
    reverse: false,
    badgeIcon: elderlySmartAssistantIcon,
    supportText: "ProductIntro.elderlyWatch.supportText",
    smartAssistantText: "ProductIntro.elderlyWatch.smartAssistantText",
    tagText: "ProductIntro.elderlyWatch.tagText",
    headingPart1: "ProductIntro.elderlyWatch.headingPart1",
    headingPart2: "ProductIntro.elderlyWatch.headingPart2",
    headingPart3: "ProductIntro.elderlyWatch.headingPart3",
    descriptionText: "ProductIntro.elderlyWatch.descriptionText",
    backgroundImage: "/media/home/ساعت سالمند.webp",
    ctaText: "ProductIntro.elderlyWatch.ctaText",
    ctaLink: "https://catalog.delbandcare.com/",
    isExternal: true,

    features: {
        control: [
            { icon: <MapPin width="22px" height="22px" />, title: "ProductIntro.elderlyWatch.features.control.0.title", description: "ProductIntro.elderlyWatch.features.control.0.description" },
            { icon: <Fence width="22px" height="22px" />, title: "ProductIntro.elderlyWatch.features.control.1.title", description: "ProductIntro.elderlyWatch.features.control.1.description" },
            { icon: <AlertTriangle width="22px" height="22px" />, title: "ProductIntro.elderlyWatch.features.control.2.title", description: "ProductIntro.elderlyWatch.features.control.2.description" },
            { icon: <Search width="22px" height="22px" />, title: "ProductIntro.elderlyWatch.features.control.3.title", description: "ProductIntro.elderlyWatch.features.control.3.description" },
        ],
        health: [
            { icon: <Gauge width="22px" height="22px" />, title: "ProductIntro.elderlyWatch.features.health.0.title", description: "ProductIntro.elderlyWatch.features.health.0.description" },
            { icon: <Heart width="22px" height="22px" />, title: "ProductIntro.elderlyWatch.features.health.1.title", description: "ProductIntro.elderlyWatch.features.health.1.description" },
            { icon: <Activity width="22px" height="22px" />, title: "ProductIntro.elderlyWatch.features.health.2.title", description: "ProductIntro.elderlyWatch.features.health.2.description" },
            { icon: <Footprints width="22px" height="22px" />, title: "ProductIntro.elderlyWatch.features.health.3.title", description: "ProductIntro.elderlyWatch.features.health.3.description" },
        ],
        special: [
            { icon: <Pill width="22px" height="22px" />, title: "ProductIntro.elderlyWatch.features.special.0.title", description: "ProductIntro.elderlyWatch.features.special.0.description" },
            { icon: <Wallet width="22px" height="22px" />, title: "ProductIntro.elderlyWatch.features.special.1.title", description: "ProductIntro.elderlyWatch.features.special.1.description" },
            { icon: <Video width="22px" height="22px" />, title: "ProductIntro.elderlyWatch.features.special.2.title", description: "ProductIntro.elderlyWatch.features.special.2.description" },
            { icon: <Sparkles width="22px" height="22px" />, title: "ProductIntro.elderlyWatch.features.special.3.title", description: "ProductIntro.elderlyWatch.features.special.3.description" },
        ],
    },
    tabs: [
        {
            key: "control",
            label: "ProductIntro.elderlyWatch.tabs.control",
            icon: (
                <div className="relative w-6 h-6 flex items-center justify-center">
                    <ShieldCheck className="w-full h-full" />
                </div>
            ),
        },
        {
            key: "health",
            label: "ProductIntro.elderlyWatch.tabs.health",
            icon: (
                <div className="relative w-6 h-6 flex items-center justify-center">
                    <Heart className="w-full h-full" />
                </div>
            ),
        },
        {
            key: "special",
            label: "ProductIntro.elderlyWatch.tabs.special",
            icon: (
                <div className="relative w-6 h-6 flex items-center justify-center">
                    <Sparkles className="w-full h-full" />
                </div>
            ),
        },
    ],
};

